import(/* webpackMode: "eager", webpackExports: ["DiscountProvider"] */ "/app/src/app/[locale]/store/_contexts/DiscountProvider.tsx");
